import { BaseApolloResponse } from '@customer-portal/shared';

export type QualtricsQuestionType = 'MC' | 'TE';
export type QualtricsSelectorType =
  | 'SAVR'
  | 'SAHR'
  | 'MAVR'
  | 'MAHR'
  | 'SL'
  | 'ML'
  | 'ESTB'
  | 'FORM';
export type QualtricsForceResponse = 'ON' | 'OFF';
export type QualtricsExpressionType = 'Expression';
export type QualtricsQuestionLoopFlag = 'yes' | 'no';
export type QualtricsConjunction = 'Or' | 'And';

export interface QualtricsSurveyModel
  extends BaseApolloResponse<QualtricsSurvey[]> {
  data: QualtricsSurvey[];
}

export interface QualtricsSurvey {
  surveyId: number;
  surveyName: string;
  surveyType?: string;
  qualtricsSurveyId: string;
  versionNumber: number;
  surveyDetails: SurveyDetails;
}

export interface SurveyDetails {
  Questions: Record<string, SurveyQuestion>;
}

export interface SurveyQuestion {
  QuestionText?: string;
  QuestionText_Unsafe?: string;
  DataExportTag?: string;
  QuestionType: QualtricsQuestionType;
  Selector: QualtricsSelectorType;
  SubSelector?: string;
  DataVisibility?: DataVisibility;
  Configuration?: Configuration;
  QuestionDescription?: string;
  Choices: ChoiceItem[];
  ChoiceOrder: number[];
  ForceResponse?: QualtricsForceResponse;

  Validation?: Validation;
  Language: QuestionLanguage;
  DefaultChoices?: boolean;
  NextChoiceId?: number;
  NextAnswerId?: number;
  QuestionID: string;
  QuestionJS?: boolean;
  GradingData?: [];
  DisplayLogic?: DisplayLogicExpression;
}

export interface DisplayLogicExpression {
  Type?: QualtricsExpressionType | string;
  ChoiceLocator?: string;
  Description?: string;
  LeftOperand: string;
  LogicType?: string;
  Operator: string;
  QuestionID?: string;
  QuestionIDFromLocator?: string;
  QuestionIsInLoop?: QualtricsQuestionLoopFlag | string;
  Conjuction?: QualtricsConjunction | string;
  [key: string]: any;
}

export interface Validation {
  settings?: {
    forceResponse?: QualtricsForceResponse;
    type?: string;
    [key: string]: any;
  };
}

export interface DataVisibility {
  private: boolean;
  hidden: boolean;
}

export interface Configuration {
  questionDescriptionOption: string;
  labelPosition?: string;
}

export interface ChoiceItem {
  display?: string;
  [key: string]: any;
}

export interface Choices {
  [key: string]: ChoiceItem;
}

export interface Question {
  Choices: Choices;
}

export interface QuestionLanguage {
  [locale: string]: {
    QuestionText: string;
    Choices?: Record<string, ChoiceItem>;
    [key: string]: any;
  };
}

export interface QualtricsSurveySubmit {
  qualtricsmsg: QualtricsMessage;
  surveyDetails: QualtricsSurveyDetailsPayload;
}

export interface QualtricsMessage {
  values: QualtricsValues;
}

export interface QualtricsValues {
  endDate?: string;
  startDate?: string;
  userLanguage?: string;
  [questionKey: string]: any;
}

export interface QualtricsSurveyDetailsPayload {
  surveyId: number;
  qualtricsSurveyId: string;
  versionNumber?: number;
  responseId?: string;
  triggerConfigurationId?: number | null;
}

export interface QualtricsSubmitResponse {
  success: boolean;
  message?: string;
  [key: string]: any;
}

export type QualtricsDisplayGroup = {
  Type?: string;
} & Record<string, SurveyQuestion | string | undefined>;

export interface QualtricsSurveyDefinition {
  elements: SurveyQuestion[];
}
